export default {
    url: '/detail/:id',
    template: `
        <courses-participations-detail
            ng-if="vm.PrivilegeService.isCompanyAdmin() || vm.PrivilegeService.canManageExternalParticipations()"
            participation="vm.participation"
            classifiers="vm.classifiers"
        />
    `,
    resolve: {
        participation (ExternalParticipationResource, $stateParams) {
            return ExternalParticipationResource.get({ id: $stateParams.id, expand: 'user,files,editor,courseDates,fields.field.activeI18n,comments' }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (participation, PrivilegeService, classifiers) {
        this.participation = participation;
        this.PrivilegeService = PrivilegeService;
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/participations/detail/index.js